import ListingDetails from "../common/ListingDetails";
import useListingDetails from "../../hooks/useListingDetails";
import { splitArray } from "src/utils/arrays";
import { InfoText } from "../common/PropertySummary";
import ExpandableContent from "../common/ExpandableContent";
import DetailsField from "../SearchListings/DetailsField";
import { convertObjectToArray } from "../../utils/objects";
import { EnumProductTypes } from "src/types/listing";
import {
  getImportedListingPrice,
} from "../../utils/listings";
import { formatCurrency } from "../../utils/numbers";
import PhoneNumbers from "../listingDetails/PhoneNumbers";
import { useNotesTagsDialogs } from "src/hooks/useNotesTagsDialogs";
import SectionHeader from "../listingDetails/SectionHeader";

const MAX_EXTRA_FIELDS = 30;
const ImportedListingDetails = ({
  title,
  listingId,
  isHideDNCPhoneNumbers,
}: {
  title: string;
  listingId: string;
  isHideDNCPhoneNumbers?: boolean;
}) => {
  const { setIsManageNotesOpen, setIsManageTagsOpen, isManageNotesOpen, isManageTagsOpen } =
    useNotesTagsDialogs();

  const {
    listing,
    isLoading,
    isError,
    handleTagsSaveClick,
    handleAddNoteClick,
    handleDeleteNoteClick,
    handleToggleContactIsDisabled
  } = useListingDetails({
    listingId,
    productType: EnumProductTypes.customupload,
    isHideDNCPhoneNumbers,
    onTagsSaved: () => {
      setIsManageTagsOpen(false);
    },
  });

  const [importedFields, otherImportedFields] = splitArray(
    listing?.extraFields
      ? convertObjectToArray(JSON.parse(listing.extraFields))
      : [],
    MAX_EXTRA_FIELDS
  );

  return (
    <ListingDetails
      listingId={listingId}
      setIsManageNotesOpen={setIsManageNotesOpen}
      setIsManageTagsOpen={setIsManageTagsOpen}
      isManageNotesOpen={isManageNotesOpen}
      isManageTagsOpen={isManageTagsOpen}
      listing={listing}
      isLoading={isLoading}
      isError={isError}
      onSaveTagsClick={handleTagsSaveClick}
      onAddNoteClick={handleAddNoteClick}
      onDeleteNoteClick={handleDeleteNoteClick}
      onToggleContactIsDisabled={handleToggleContactIsDisabled}
      PropertyDetailsProps={{
        customSection1Content: listing && (
          <div className="flex gap-4 flex-wrap items-center">
            <InfoText
              title={"Price"}
              info={
                getImportedListingPrice(listing)
                  ? formatCurrency(getImportedListingPrice(listing))
                  : "--"
              }
            />
            <InfoText title="Landvoice ID" info={listing?.id} />
            <InfoText
              title="Date Processed"
              info={listing.formattedPublishDate}
            />
          </div>
        ),
      }}
    >
      {!isLoading && !isError && listing && (
        <>
          <div className=" flex flex-col gap-12 mt-6 print:gap-2 print:mt-2">
            <section>
              <SectionHeader title="Imported Fields" />
              <div>
                {importedFields?.length ? (
                  <ExpandableContent
                    showMoreLabel={`Show ${otherImportedFields.length} more fields`}
                    content={
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                        {importedFields.map(({ name, value }) => (
                          <DetailsField
                            key={name}
                            fieldLabel={name}
                            fieldValue={value || ""}
                          />
                        ))}
                      </div>
                    }
                    moreContent={
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                        {otherImportedFields.map(({ name, value }) => (
                          <DetailsField
                            key={name}
                            fieldLabel={name}
                            fieldValue={value || ""}
                          />
                        ))}
                      </div>
                    }
                  />
                ) : (
                  <div className="text-gray-primary">No imported fields</div>
                )}
              </div>
            </section>
            {listing.contacts && listing.contacts.length > 0 && (
              <section className="max-w-[729px]">
                <PhoneNumbers contacts={listing.contacts} />
              </section>
            )}
          </div>
        </>
      )}
    </ListingDetails>
  );
};

export default ImportedListingDetails;
